/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).on('click', '.ProductItem__SizeSwatchList .ProductItem__SizeSwatchItem:not(.disabled)',function() {
  var SizeId = $(this).find('.SizeSwatch__Radio').attr("data-id");
  addItemToCart(SizeId, 1)
});
$(document).on('click', '.Drawer__Close',function() {
  $('html').removeClass('no-scroll');
  $('.PageOverlay').removeClass('is-visible');
  $('#sidebar-cart').attr('aria-hidden', true);
});
function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.dispatchEvent(new CustomEvent('theme:loading:end')); // Then we add the product in Ajax
      $(".Header__CartCount").click();
    },
    error:function (e) {
      document.dispatchEvent(new CustomEvent('theme:loading:end')); // Then we add the product in Ajax
      alert(e.responseJSON.description)
    }
  });
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
  }));
}
if($(window).width() < 767)
{
  $(window).scroll(function(){
    var bannerHeight = $(".marquee__container").height();
    if ($(window).scrollTop() >= bannerHeight) {
      $('#section-header').addClass('header-fixed');
    }
    else {
      $('#section-header').removeClass('header-fixed');
    }
  });
}

$(function ($) {
  $(".recomended-svg").click(function(event) {
    $(this).closest(".ProductItem__Image--alternate-flex").find(".features-media-rec").animate({scrollLeft: '+='+$(".features-media-rec").outerWidth()}, 250); 
  })
  $(".recomended-svg-left").click(function(event) {
    $(this).closest(".ProductItem__Image--alternate-flex").find(".features-media-rec").animate({scrollLeft: '-='+$(".features-media-rec").outerWidth()}, 250); 
  })
});